import { LineColor } from './line.js';

export const DEFAULT_BRUSH_COLOR = LineColor.Blue;
